const makeEnumTranslator = (translations) => {
  const langFor = (enumObj, key, lang) => {
    const enumName = enumObj.ENUM_NAME;
    if (!(enumName in translations)) {
      throw new Error(`Translation missing for '${enumName}'`);
    }
    if (!(key in translations[enumName])) {
      throw new Error(`Translation missing for '${enumName}.${key}'`);
    }
    return translations[enumName][key][lang] ?? '???';
  };

  return { langFor };
};

export { makeEnumTranslator };
